import { getCapitalizedString } from 'src/app/shared/utils';
import { Calc } from 'src/app/shared/utils/calc';
import { SeverityType } from '../../../alarms/services/alarms.types';
import { BatterySeverities, Status, TransmissionReadRate } from '../../health-api.types';
import { ReadRateBarChart, ReadRateStatistic, TransmissionField } from '../../health-monitor.types';

function createReadRate(): ReadRateBarChart[] {
  return [
    { color: '#a5ce9b', count: 0, width: 0, title: SeverityType.Good },
    { color: '#D7DEF9', count: 0, width: 0, title: SeverityType.Notice },
    { color: '#FFD568', count: 0, width: 0, title: SeverityType.Warning },
    { color: '#FB9C8B', count: 0, width: 0, title: SeverityType.Severe },
    { color: '#9A3725', count: 0, width: 0, title: SeverityType.Critical }
  ];
}

function updateSingleDeviceCount(devices: BatterySeverities[]): ReadRateBarChart[] {
  const readRate: ReadRateBarChart[] = createReadRate();
  devices.forEach((device: BatterySeverities) => {
    device.severities.forEach(status => {
      const currentStatus = readRate.find(rate => getCapitalizedString(status.key) === rate.title);

      if (currentStatus) {
        currentStatus.count += status.value;
      }
    });
  });

  return readRate;
}

function calculateReadRatePercent(readRate: ReadRateBarChart[], totalCount: number): ReadRateBarChart[] {
  const readRates = readRate.map((chart: ReadRateBarChart) => ({
    ...chart,
    width: totalCount ? Math.round(Calc.percent(chart.count, totalCount) as number) : 0
  }));

  const totalCountExceptUnknown = readRates.reduce((acc, current) => {
    return current.title === SeverityType.Unknown ? 0 : acc + current.width;
  }, 0);

  return readRates.map(rate => {
    const totalPercent = 100;

    if (totalCountExceptUnknown && rate.title === SeverityType.Unknown) {
      rate.width = totalPercent - totalCountExceptUnknown;
    }

    return {
      ...rate
    };
  });
}

function calculateAllDevicesTotalCount(devices: TransmissionReadRate, field: TransmissionField): number {
  if (!devices[field]) {
    return 0;
  }
  return devices[field].reduce((count, device) => {
    return (
      count +
      device.severities.reduce((acc, current) => {
        let value = current.value;
        if (current.key === Status.Unknown) {
          value = 0;
        }
        return acc + value;
      }, 0)
    );
  }, 0);
}

export function calculateReadRateStatistic(devices: TransmissionReadRate): ReadRateStatistic {
  const readRateTotalCount = calculateAllDevicesTotalCount(devices, 'transmissionReadRateCount');
  const validReadRateTotalCount = calculateAllDevicesTotalCount(devices, 'validTransmissionReadRateCount');

  const readRate = calculateReadRatePercent(
    updateSingleDeviceCount(devices.transmissionReadRateCount),
    readRateTotalCount
  );

  const validReadRate = calculateReadRatePercent(
    updateSingleDeviceCount(devices.validTransmissionReadRateCount),
    validReadRateTotalCount
  );

  return {
    readRate,
    validReadRate
  };
}
